import {
  Component, OnInit, AfterViewInit, OnDestroy,
  Input, Output, Pipe, PipeTransform, EventEmitter, ViewChild
} from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
// import 'emojioneArea';
import 'jquery-textcomplete';
import { CommonService } from '../../../commons/services/common.service';
import { DomSanitizer } from '@angular/platform-browser';

declare var _: any;
declare var $: any;

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
@Component({
  selector: 'app-messages-bon',
  templateUrl: './messages-bon.component.html',
  styleUrls: ['./messages-bon.component.css']
})
export class MessagesBonComponent implements OnInit, AfterViewInit {
  @Input() row;
  @Input() listOpBenne;
  @Input() depuisPlanning;
  @Output() hidefunction = new EventEmitter<any>();
  @Output() btnValider = new EventEmitter<any>();
  @Output() btnModifDate = new EventEmitter<any>();
  @Output() btnDocument = new EventEmitter<any>();
  @Output() btnImprimeBon = new EventEmitter<any>();
  @Output() btnImprimeBSD = new EventEmitter<any>();
  listFil = [];
  isNew: Boolean = false;
  msg = '';
  user: any = {};
  nomFil = '';
  selectedFil: any = {};
  selectedService: any = {};
  selectedType: any = {};
  listMessageBon: any = [];
  listDate = [];
  avatar = '';
  services = [
    { id: 0, libelleObjetEntite: 'Exploitation' },
    { id: 1, libelleObjetEntite: 'Facturation' },
    { id: 2, libelleObjetEntite: 'Autre' }
  ];
  typeDemandes = [];
  mouvementsRows = [];
  i18n = {
    search: 'Recherche', categories: {
      search: 'Résultats de recherche', recent: 'Récents', people: 'Smileys & People',
      nature: 'Animals & Nature',
      foods: 'Food & Drink',
      activity: 'Activity',
      places: 'Travel & Places',
      objects: 'Objects',
      symbols: 'Symbols',
      flags: 'Flags',
      custom: 'Custom',
    }
  };
  height = 50;
  societe: any = {};
  errorPopup = '';

  @ViewChild('msgPopup') msgPopup;
  constructor(public common: CommonService, public modalService: BsModalService) {
  }

  ngOnInit() {
    console.log('ngOnInit() fil discussion called');
    console.log(this.row);
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.listOpBenne = this.listOpBenne || [];
    this.mouvementsRows = [this.row];
    this.mouvementsRows.forEach(elt => {
      if (elt.chantier) {
        elt.chantier.libelleObjetEntite = elt.chantier.numChantier || elt.chantier.responsable || elt.chantier.ville;
      }
    })
    const u = this.common.local.getObject('userDetail') || {};
    this.user = u;
    this.loadEmoji();
    this.getMessageBon();
  }

  ngAfterViewInit() {
  }

  loadEmoji() {
    const ctrl = this;
    $('#comment').emojioneArea({
      pickerPosition: 'top',
      tonesStyle: 'bullet',
      recentEmojis: false,
      autocomplete: false, // Pour contourner l'erreur de jquery-textcomplete
      searchPlaceholder: 'Rechercher',
      events: {
        change: function (editor, event) {
          ctrl.msg = editor.html();
        },
        keydown: function (editor, event) {
          const element = $('#comment').data('emojioneArea').editor;
          $(element).attr('id', 'emojioneAreaReply');
          if (event.keyCode === 13 || event.keyCode === 10) {
            // Ctrl-Enter pressed
            if (!event.ctrlKey && !event.shiftKey) {
              ctrl.msg = editor.html();
              ctrl.envoieMessage();
              return false;
            } else {
              if (event.ctrlKey) {
                ctrl.pasteHtmlAtCaret('<br></br>');
                return true;
              } else {
                if (event.shiftKey) {
                  return true;
                }
              }
            }
          }
        },
      }
    });
  }

  pasteHtmlAtCaret(html) {
    let sel, range;
    if (window.getSelection) {
      // IE9 and non-IE
      sel = window.getSelection();
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();

        // Range.createContextualFragment() would be useful here but is
        // non-standard and not supported in all browsers (IE9, for one)
        const el = document.createElement('div');
        el.innerHTML = html;
        const frag = document.createDocumentFragment();
        let node, lastNode;
        while ((node = el.firstChild)) {
          lastNode = frag.appendChild(node);
        }
        range.insertNode(frag);
        // Preserve the selection
        if (lastNode) {
          range = range.cloneRange();
          range.setStartAfter(lastNode);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    } /*else if (document.selection && document.selection.type !== 'Control') {
      // IE < 9
      document.selection.createRange().pasteHTML(html);
  }*/
  }

  sortFunc(a, b) {
    return b.time - a.time;
  }

  getMessageBon() {
    const param = {
      'servlet': 'DBGestionMessage',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CLEF_BON': {
          'typeParam': 'int',
          'valeur': this.row.bon.id
        },
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.user['id']
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      if (datas.data) {
        this.listDate = datas.data[0];
        this.listMessageBon = datas.data[1];

        for (const key in this.listMessageBon) {
          if (key) {
            this.listMessageBon[key].forEach(elt => {
              const date = elt.date + ' ' + elt.heure;
              const dateTime = moment(date, 'DD/MM/YYYY HH:mm:ss');
              elt.time = dateTime.toDate().getTime();
            });
          }
        }
      } else {
        if (datas.message && datas.message.includes('Utilisateur non-autentifié ou la session a expiré')) {
          // this.common.logoutEcoportail();
        } else {
          console.log(datas);
        }
      }
      this.loadEmoji();
    });
  }

  filterBy(data, prop: string) {
    return data.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }

  filterDate(data) {

    return data.sort((a, b) => {
      const date1 = moment(a, 'DD/MM/YYYY').toDate().getTime();
      const date2 = moment(b, 'DD/MM/YYYY').toDate().getTime();
      return date1 > date2 ? 1 : date1 === date2 ? 0 : -1;
    });
  }

  envoieMessage() {
    const ctrl = this;
    const msg = this.msg;
    const message = this.common.parseMessage(msg);
    const objMessageLite = {
      message: message,
      nomclass: 'MessageLite',
      clefEnregistrementTable: this.row.bon.id,
      clefUser: this.user.id
    };

    const param = {
      'servlet': 'DBGestionMessage',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'MESSAGE': objMessageLite
      }
    };

    this.common.post('', { param: param }).then(data => {
      if (this.common.verifySession(data)) {
        if (!data.message) {
          this.msg = '';
          $('#comment').data('emojioneArea').setText('');
          ctrl.getMessageBon();
        } else {
          console.log(data.message);
        }
      }
    }).catch(error => {
      console.log(error);
    });
  }

  getDate(item) {
    return this.common.parseDate(moment(item, 'DD/MM/YYYY'));
  }

  getNameFile(event) {
    const elem = {};
    let index;
    let isImage;
    const file = event.target.files[0];
    
    if(!this.common.checkExtFichierImgEtTexte(file.name)) {
      this.errorPopup = this.common.msgErreurExtensionFichier;
      this.common.openModal(this.modalService, this.msgPopup);
      return;
    }        
    
    elem['nomFichier'] = file.name;
    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/svg+xml'];
    if (validImageTypes.includes(file.type)) {
      isImage = true;
    }
    /*elem.type = file.type;
    elem.taille = file.size; */
    const fileReader = new FileReader();
    const ctrl = this;
    for (const item in this.listMessageBon) {
      if (item === moment().format('DD/MM/YYYY')) {
        console.log(item);
        index = item;
      }
    }
    if (!index) {
      index = moment().format('DD/MM/YYYY');
      this.listMessageBon[moment().format('DD/MM/YYYY')] = [];
    }
    fileReader.onload = function () {
      const base64 = (<string>fileReader.result).split(',');
      elem['contenuBase64'] = base64[1];
      elem['imagePath'] = fileReader.result;
      ctrl.listMessageBon[index].push({
        id: ctrl.listMessageBon[index].length + 1,
        clefUserEcoGED: ctrl.user['id'],
        isFile: true,
        content: elem['imagePath'],
        nomFichier: elem['nomFichier'],
        type: file.type,
        heure: moment().format('HH:mm'),
        image: isImage || false,
      });
      ctrl.listMessageBon[index] = [...ctrl.listMessageBon[index]];
      console.log( ctrl.listMessageBon[index]);
    };
    fileReader.readAsDataURL(file);
  }

  typeContenantToString(typeContenant) {
    if (typeContenant.familleContenant && (typeContenant.familleContenant.libelle === 'Tous'
      || typeContenant.familleContenant.libelle === 'Aucun' || typeContenant.familleContenant.libelle === '\u00c0 d\u00e9finir')) {
      return typeContenant.familleContenant.libelle;
    } else {
      let descriptif = '';

      if (typeContenant.familleContenant) {
        descriptif = typeContenant.familleContenant.libelle + ' ';
      }

      if (typeContenant.cubageContenant) {
        descriptif += typeContenant.cubageContenant.cubage;
      }

      if (typeContenant.uniteContenant) {
        descriptif += typeContenant.uniteContenant.libelle;
      }

      if (typeContenant.codeAgenceEau !== '') {
        descriptif += ' (AG EAU: ' + typeContenant.codeAgenceEau + ')';
      }
      return descriptif;
    }
  }

  closeFct() {
    this.hidefunction.emit(this.row);
  }

  preValidation(row) {
    this.btnValider.emit(row);
    this.closeFct();
  }

  openDialogChangerDatePrevue(row) {
    this.btnModifDate.emit(row);
  }
  openPopFichier(row) {
    this.btnDocument.emit(row);
  }

  printBon(row) {
    this.btnImprimeBon.emit(row);
  }
  getListBsdd(row) {
    this.btnImprimeBSD.emit(row);
  }

  getHeight() {
    return `calc(100% - ${($('#headerMsg').height() ? ($('#headerMsg').height() + 10) : 0) + ($('#prestation').height())}px)`;
  }
}

